import React from "react";
import CrudResource from "./CrudResource";

const fields = [
  { key: "title_tr", label: "Başlık (TR)" },
  { key: "title_en", label: "Başlık (EN)" },
  { key: "brand_name", label: "Marka" },
  { key: "video_url", label: "YouTube / Shorts / Vimeo URL", span: 2 },
  { key: "order", label: "Sıra", type: "number" },
  { key: "active", label: "Aktif", type: "checkbox" },
];
const defaults = { title_tr: "", title_en: "", brand_name: "", video_url: "", order: 100, active: true };

export default function AdminShorts() {
  return (
    <CrudResource
      resource="shorts"
      publicPath="shorts"
      title="Viral İşler (YouTube Shorts)"
      fields={fields}
      defaults={defaults}
    />
  );
}
